import React from "react";

/**
 * Drifting orb backdrop.
 *
 * Entirely CSS — see the `.orb-field` / `.orb-*` rules in index.css. The orb
 * colours read straight from the --u-* tokens, so this follows the active theme
 * with no JS involvement, and the animation is transform-only so it stays on
 * the compositor.
 */
const HeroBackground = () => (
  <div className="orb-field" aria-hidden="true">
    <div className="orb orb-1" />
    <div className="orb orb-2" />
    <div className="orb orb-3" />
    <div className="orb orb-4" />
  </div>
);

export default HeroBackground;
